function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.222 10.9L8.17 7.952 5.222 5.006h0L5.216 5a1.167 1.167 0 011.65-1.65h0l.006.007 3.771 3.77h0a1.167 1.167 0 010 1.65h0L6.872 12.55h0l-.006.006a1.167 1.167 0 01-1.65-1.65h0l.006-.006z",
  fill: "#000",
  stroke: "#000"
}));